import { render, staticRenderFns } from "./CPageStaffDetailStandard.vue?vue&type=template&id=4d49da65&"
import script from "./CPageStaffDetailStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageStaffDetailStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports